import React from "react";
import { compose } from "recompose";
import { connect } from "react-redux";

import { Api } from "@api/index";
import { connectToApi } from "@api/components/connectToApi";
import { DownloadCsvButton } from "@ui/DownloadCsvButton";
import { PlaylistTrackListTable } from "../PlaylistTrackListTable";
import { VendorState as State, PlaylistTrack } from "../../models";
import { getPlaylistTracksListEntities } from "../../selectors";

interface OwnedTracksListStateProps {
    playlistTracks: PlaylistTrack[];
}

type Props = OwnedTracksListStateProps;

const OwnedTracksList = ({ playlistTracks }: Props) => (
    <div className="owned-tracks-list">
        <PlaylistTrackListTable playlistTracks={playlistTracks} />
        <DownloadCsvButton actionCreator={Api.vendorTracksIndexDownload} />
    </div>
);

const mapStateToProps = (state: State) => ({
    playlistTracks: getPlaylistTracksListEntities(state),
} as OwnedTracksListStateProps);

const ConnectedOwnedTracksList = compose<Props, {}>(
    connect(mapStateToProps, null),
    connectToApi({
        showRefresh: false,
        actionCreator: Api.vendorTracksIndex,
    }),
)(OwnedTracksList);

export {
    OwnedTracksList as OwnedTracksListPresenter,
    ConnectedOwnedTracksList as OwnedTracksList,
};
